import React, { useState, useEffect } from "react";
import api from '../../api/api';
import countryState from '../../data/gistfile.json';
import {
  Card,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  Button
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export default function UserAccountDetails() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [description, setDescription] = useState("");

  const [other, setOther] = useState("");
  
  const [allCountry, setAllCountry] = useState([]);
  const [allStates, setAllStates] = useState([]);

  const [toggle, setToggle] = useState(false);

  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState(""); 

  const [currentMdpError, setCurrentPassErr] = useState("");
  const [newMdpError, setNewPassErr] = useState("");
  const [confMdpErr, setconfMdpErr] = useState("");

  const [msgServer, setMsgServer] = useState("");
  const [classMsg, setClassMsg] = useState("");
  const [displayMsg, setDisplayMsg] = useState("hide");
  const [iconMsg, setIconMsg] = useState("info");
  
  const [isSaving, setIsSaving] = useState(false);
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);

  let listcountry = [];
  let liststateSelectedCountry = [];

  const [errorMsg, setErrorMsg] = useState({
    nameError: "", 
    emailError: "", 
    passwordError: "",
    zipError: "",
    touched: {
      name: false,
      email: false,
      password: false,
      newPassword: false,
      confirmPass: false,
      zip: false
    }
  });
  
  const { t } = useTranslation();

  const getProfileErrorMessage = (errorOrData) => {
    const data = errorOrData?.response?.data || errorOrData || {};
    const code = data.message || data.errors?.[0]?.msg;
    const fallbackMessages = {
      name_empty: 'Le nom est obligatoire.',
      name_invalid_format: 'Le nom doit contenir au moins une lettre.',
      name_only_digits: 'Le nom ne peut pas contenir uniquement des chiffres.',
      email_empty: "L’adresse email est obligatoire.",
      email_invalid_format: "Le format de l’adresse email est invalide.",
      email_already_exists: 'Cette adresse email est déjà utilisée par un autre compte.',
      zip_only_digits: 'Le code postal doit contenir uniquement des chiffres.',
      error_save_user_profil: 'Le profil n’a pas pu être enregistré. Veuillez réessayer.',
      error_user: 'Le profil utilisateur est indisponible.',
    };

    if (!code) return t('error_save_change');
    const translated = t(code);
    return translated !== code ? translated : (fallbackMessages[code] || t('error_save_change'));
  };

  // Fonction pour émettre l'événement de mise à jour du profil
  const notifyProfileUpdated = () => {
    const event = new Event('profileUpdated');
    window.dispatchEvent(event);
  };

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleBlur = (field) => {
    setErrorMsg(prev => ({
      ...prev,
      touched: {
        ...prev.touched,
        [field]: true
      }
    }));
    
    validateField(field);
  };
  
  const validateField = (field) => {
    switch (field) {
      case 'name':
        let nameError = '';
        if (!name || name.trim() === "") {
          nameError = t('name_empty');
        } else if (!/[a-zA-Z]/.test(name)) {
          nameError = t('name_invalid_format');
        } else if (/^\d+$/.test(name)) {
          nameError = t('name_only_digits');
        }
        setErrorMsg(prev => ({ ...prev, nameError }));
        break;

      case 'email':
        let emailError = '';
        if (!email || email.trim() === "") {
          emailError = t('email_empty');
        } else if (!validateEmail(email)) {
          emailError = t('email_invalid_format');
        }
        setErrorMsg(prev => ({ ...prev, emailError }));
        break;

      case 'zip':
        let zipError = '';
        if (zip_code && !/^\d*$/.test(zip_code)) {
          zipError = t('zip_only_digits');
        }
        setErrorMsg(prev => ({ ...prev, zipError }));
        break;
        
      default:
        break;
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    
    if (errorMsg.touched.name) {
      let nameError = '';
      if (!value || value.trim() === "") {
        nameError = t('name_empty');
      } else if (!/[a-zA-Z]/.test(value)) {
        nameError = t('name_invalid_format');
      } else if (/^\d+$/.test(value)) {
        nameError = t('name_only_digits');
      }
      setErrorMsg(prev => ({ ...prev, nameError }));
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (errorMsg.touched.email) {
      let emailError = '';
      if (!value || value.trim() === "") {
        emailError = t('email_empty');
      } else if (!validateEmail(value)) {
        emailError = t('email_invalid_format');
      }
      setErrorMsg(prev => ({ ...prev, emailError }));
    }
  };

  const loadProfileData = async () => {
    try {
      const res = await api.get('/profil');
      const newData = res.data;
      
      setName(newData.result.name);
      setEmail(newData.result.email);
      setAddress(newData.result.address);
      setCity(newData.result.city);
      setOther(newData.result.city);
      setCountry(newData.result.country);
      setZipCode(newData.result.zip_code);
      setDescription(newData.result.description);
      
      if (newData.result.country) {
        const selectedCountryObj = countryState.countries.find(c => c.country === newData.result.country);
        if (selectedCountryObj && selectedCountryObj.states) {
          setAllStates(selectedCountryObj.states);
        }
      }
    } catch (error) {
      console.error("Erreur lors du chargement des données du profil:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      countryState.countries.forEach((item) => {
        listcountry.push(item.country);
      });
      setAllCountry(listcountry);
      
      await loadProfileData();
    };
    
    fetchData();
  }, []);

  useEffect(() => {
    if (isSuccessVisible) {
      const timer = setTimeout(() => {
        setIsSuccessVisible(false);
        setDisplayMsg('hide');
      }, 3000); 
      
      return () => clearTimeout(timer);
    }
  }, [isSuccessVisible]);

  const validate = () => {
    let isValid = true;
    let nameError = '';
    let emailError = '';
    let zipError = '';

    // Name validation
    if (!name || name.trim() === "") {
      nameError = t('name_empty');
      isValid = false;
    } else if (!/[a-zA-Z]/.test(name)) {
      nameError = t('name_invalid_format');
      isValid = false;
    } else if (/^\d+$/.test(name)) {
      nameError = t('name_only_digits');
      isValid = false;
    }

    // Email validation
    if (!email || email.trim() === "") {
      emailError = t('email_empty');
      isValid = false;
    } else if (!validateEmail(email)) {
      emailError = t('email_invalid_format');
      isValid = false;
    }

    // ZIP code validation
    if (zip_code && !/^\d*$/.test(zip_code)) {
      zipError = t('zip_only_digits');
      isValid = false;
    }

    setErrorMsg(prev => ({
      ...prev,
      nameError,
      emailError,
      zipError,
      touched: {
        ...prev.touched,
        name: true,
        email: true,
        zip: true
      }
    }));
    
    return isValid;
  };

  const handleCountry = (selectedCountry) => {
    setCountry(selectedCountry);
    
    const selectedCountryObj = countryState.countries.find(c => c.country === selectedCountry);
    
    if (selectedCountryObj && selectedCountryObj.states) {
      setAllStates(selectedCountryObj.states);
    } else {
      setAllStates([]);
    }
  };

  const handleZipChange = (e) => {
    const value = e.target.value;
    
    if (value === '' || /^\d*$/.test(value)) {
      setZipCode(value);
      
      if (errorMsg.zipError && errorMsg.touched.zip) {
        setErrorMsg(prev => ({ ...prev, zipError: '' }));
      }
    } else {
      setErrorMsg(prev => ({
        ...prev,
        zipError: t('zip_only_digits'),
        touched: {
          ...prev.touched,
          zip: true
        }
      }));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
      handlSaveProfil();
    }
  };

const handlSaveProfil = () => {
  const dataPost = {
    name: name,
    email: email,
    address: address,
    city: city,
    country: country,
    zip_code: zip_code,
    description: description
  };

  setIsSaving(true); 

  MySwal.fire({
    title: t('update_profile_confirm_title'),
    text: t('update_profile_confirm_text'),
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: t('yes_save'),
    cancelButtonText: t('cancel'),
    confirmButtonColor: '#3CB379',
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
      api.post('/edit-profil', dataPost)
        .then(res => {
          setIsSaving(false); // Fin de l'enregistrement

          if(res.data.type && res.data.type === "danger") {
            MySwal.fire({
              title: t('Error'),
              text: getProfileErrorMessage(res.data),
              icon: 'error',
              confirmButtonColor: '#3CB379'
            });
          }
          if(res.data.type && res.data.type === "success") {
            
            let user = JSON.parse(localStorage.getItem("user") || "{}");
            if (!user) user = {}; 
            
            user.name = name;
            user.email = email;
            user.description = description; 
            
            
            if (user.avatar === undefined && res.data.avatar) {
              user.avatar = res.data.avatar;
            }
            
            localStorage.setItem("user", JSON.stringify(user));

            setMsgServer(res.data.message);
            setClassMsg('success');
            setIconMsg('check-circle');
            setDisplayMsg('show');
            setIsSuccessVisible(true);
            
          
            MySwal.fire({
              title: t('Success'),
              text: t(res.data.message),
              icon: 'success',
              confirmButtonColor: '#3CB379'
            });

            notifyProfileUpdated();
            
            window.dispatchEvent(new Event("user-updated"));
            
            const event = new CustomEvent('name-updated', { 
              detail: { 
                name: name 
              } 
            });
            window.dispatchEvent(event);
          }
        })
        .catch((error) => {
          setIsSaving(false);
          MySwal.fire({
            title: t('Error'),
            text: getProfileErrorMessage(error),
            icon: 'error',
            confirmButtonColor: '#3CB379'
          });
          console.error("Erreur lors de la mise à jour:", error);
        });
    } else {
      setIsSaving(false); 
    }
  });
};

  // Password validation --> lezem minimum 6 caractères
  const validatePass = () => {
    let isValid = true;
    let currentMdpError = '';
    let newMdpError = '';
    let confMdpErr = '';
    
    if (!password) {
      currentMdpError = t('current_password_required');
      isValid = false;
    }

    if (!newPassword) {
      newMdpError = t('new_password_required');
      isValid = false;
    } else if (newPassword.length < 6) {
      newMdpError = t('password_min_length');
      isValid = false;
    }

    if (!confirmPass) {
      confMdpErr = t('confirm_password_required');
      isValid = false;
    } else if (newPassword !== confirmPass) {
      confMdpErr = t('passwords_dont_match');
      isValid = false;
    }
    
    setCurrentPassErr(currentMdpError);
    setNewPassErr(newMdpError);
    setconfMdpErr(confMdpErr);
    
    return isValid;
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    
    if (!value) {
      setCurrentPassErr(t('current_password_required'));
    } else {
      setCurrentPassErr('');
    }
  };

  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);

    if (!value) {
      setNewPassErr(t('new_password_required'));
    } else if (value.length < 6) {
      setNewPassErr(t('password_min_length'));
    } else {
      setNewPassErr('');
    }

    if (confirmPass && value !== confirmPass) {
      setconfMdpErr(t('passwords_dont_match'));
    } else if (confirmPass) {
      setconfMdpErr('');
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPass(value);

    if (!value) {
      setconfMdpErr(t('confirm_password_required'));
    } else if (newPassword !== value) {
      setconfMdpErr(t('passwords_dont_match'));
    } else {
      setconfMdpErr('');
    }
  };

  const handleSubmitPass = (e) => {
    e.preventDefault();
    if (validatePass()) {
      handleChangePass();
    }
  };
  
  const handleChangePass = () => {
    const data = {
      password: password,
      newPassword: newPassword,
      confirmNewPassword: confirmPass
    };
    
    setIsSaving(true); 
    
    MySwal.fire({
      title: t('change_password_confirm_title'),
      text: t('change_password_confirm_text'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('yes_change'),
      cancelButtonText: t('cancel'),
      confirmButtonColor: '#3CB379',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        api.post('/profil/changepassword', data)
          .then(res => {
            setIsSaving(false);

            if(res.data.type && res.data.type === "danger") {
              MySwal.fire({
                title: t('Error'),
                text: t(res.data.message),
                icon: 'error',
                confirmButtonColor: '#3CB379',
              });
            }
            if(res.data.type && res.data.type === "success") {
              resetForm();

              setMsgServer(res.data.message);
              setClassMsg('success');
              setIconMsg('check-circle');
              setDisplayMsg('show');
              setIsSuccessVisible(true);

              MySwal.fire({
                title: t('Success'),
                text: t(res.data.message),
                icon: 'success',
                confirmButtonColor: '#3CB379',
              });
            }
          })
          .catch((error) => {
            setIsSaving(false);
            MySwal.fire({
              title: t('Error'),
              text: t('error_save_change'),
              icon: 'error',
              confirmButtonColor: '#3CB379',
            });
            console.error("Erreur lors du changement de mot de passe:", error);
          });
      } else {
        setIsSaving(false); 
      }
    });
  };

  const resetForm = () => {
    setPassword("");
    setNewPassword("");
    setConfirmPass("");
    setCurrentPassErr("");
    setNewPassErr("");
    setconfMdpErr("");
  };

  const getPasswordStrength = (password) => {
    if (!password) return { strength: 0, text: '', color: '' };
    
    let strength = 0;
    
    if (password.length >= 6) strength += 2;
    if (password.length >= 8) strength += 1;
    if (/[A-Z]/.test(password)) strength += 1; 
    if (/[0-9]/.test(password)) strength += 1;
    
    const strengthText = [
      t('strength_very_weak'),
      t('strength_weak'),
      t('strength_medium'),
      t('strength_strong'),
      t('strength_very_strong'),
    ];
    const strengthColor = ['#ff4d4d', '#ffa64d', '#ffff4d', '#4dff4d', '#4d4dff'];
    
    return {
      strength: strength,
      text: strengthText[Math.min(strength, 4)] || '',
      color: strengthColor[Math.min(strength, 4)] || ''
    };
  };
  
  const passwordStrength = getPasswordStrength(newPassword);

  return (
    <Card className="profile-account-card">
      <Card.Header className="profile-account-header">
        <span className="profile-section-icon">
          <i className="far fa-user" aria-hidden="true" />
        </span>
        <div>
          <span className="profile-section-eyebrow">SMARTFARM</span>
          <h2>{t("profile_personal_info", { defaultValue: "Informations personnelles" })}</h2>
          <p>{t("profile_personal_info_help", { defaultValue: "Mettez à jour les coordonnées associées à votre compte." })}</p>
        </div>
      </Card.Header>
      <ListGroup flush>
        <ListGroupItem className="profile-account-body">
          <div className={`profile-form-alert alert alert-${classMsg} fade ${displayMsg}`}>
            <i className={`fa fa-${iconMsg} mx-2`}></i> {t(msgServer)}
          </div>
          <Row>
            <Col>
              <Form className="profile-form">
                <Row className="profile-form-grid profile-form-grid--two">
                  {/* First Name */}
                  <Col className="form-group">
                    <label htmlFor="feFirstName">{t('name')} <span className="text-danger">*</span></label>
                    <Form.Control
                      id="feFirstName"
                      placeholder={t('name')}
                      className={errorMsg.touched.name && errorMsg.nameError ? 'is-invalid' : ''}
                      value={name}
                      onChange={handleNameChange}
                      onBlur={() => handleBlur('name')}
                      disabled={isSaving}
                    />
                    {errorMsg.touched.name && errorMsg.nameError && (
                      <div className="invalid-feedback">{errorMsg.nameError}</div>
                    )}
                  </Col>
                  {/* Email */}
                  <Col className="form-group">
                    <label htmlFor="feEmail">{t('email')} <span className="text-danger">*</span></label>
                    <Form.Control
                      type="email"
                      id="feEmail"
                      placeholder={t('email')}
                      className={errorMsg.touched.email && errorMsg.emailError ? 'is-invalid' : ''}
                      value={email}
                      onChange={handleEmailChange}
                      onBlur={() => handleBlur('email')}
                      autoComplete="email"
                      disabled={isSaving}
                    />
                    {errorMsg.touched.email && errorMsg.emailError && (
                      <div className="invalid-feedback">{errorMsg.emailError}</div>
                    )}
                  </Col>
                </Row>
                <Form.Group className="profile-form-group">
                  <label htmlFor="feAddress">{t('address')}</label>
                  <Form.Control
                    id="feAddress"
                    placeholder={t('address')}
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    disabled={isSaving}
                  />
                </Form.Group>
                <Row className="profile-form-grid profile-form-grid--location">
                  {/* State */}
                  <Col className="form-group">
                    <label htmlFor="feInputState">{t('state')}</label>
                    <Form.Select 
                      id="feInputState" 
                      value={country || ""} 
                      onChange={(e) => handleCountry(e.target.value)}
                      disabled={isSaving}
                    >
                      <option value="">{t('choose_ellipsis')}</option>
                      {allCountry.map((country, i) => (
                        <option key={i} value={country}>{country}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  {/* City */}
                  <Col className="form-group">
                    <label htmlFor="feCity">{t('city')}</label>
                    <Form.Select
                      id="feCity"
                      placeholder={t('city')}
                      value={city || ""}
                      onChange={(e) => setCity(e.target.value)}
                      disabled={isSaving}
                    >
                      <option value="">{other || t('choose_ellipsis')}</option>
                      {allStates.map((state, i) => (
                        <option key={i} value={state}>{state}</option>
                      ))}
                    </Form.Select>
                    <div className="profile-other-city">
                      <input 
                        type="checkbox" 
                        name="Autre" 
                        id="check" 
                        className="me-1"
                        onClick={() => setToggle(!toggle)} 
                        disabled={isSaving}
                      /> 
                      <label htmlFor="check">{t('other')}</label>
                    </div>

                    {toggle && (
                      <Form.Control 
                        className="profile-other-city-input"
                        placeholder={t('city')}
                        onChange={(e) => setCity(e.target.value)}
                        disabled={isSaving}
                      />
                    )}
                  </Col>
                  {/* controle de saisie pour --> Zip Code */}
                  <Col className="form-group">
                    <label htmlFor="feZipCode">{t('zip')}</label>
                    <Form.Control
                      id="feZipCode"
                      placeholder={t('zip')}
                      value={zip_code}
                      onChange={handleZipChange}
                      onBlur={() => handleBlur('zip')}
                      className={errorMsg.touched.zip && errorMsg.zipError ? 'is-invalid' : ''}
                      disabled={isSaving}
                    />
                    {errorMsg.touched.zip && errorMsg.zipError && (
                      <div className="invalid-feedback">{errorMsg.zipError}</div>
                    )}
                  </Col>
                </Row>
                <Row className="profile-form-description">
                  {/* Description */}
                  <Col md="12" className="form-group">
                    <label htmlFor="feDescription">{t('desc')}</label>
                    <Form.Control 
                      as="textarea" 
                      id="feDescription" 
                      rows="5" 
                      onChange={(e) => setDescription(e.target.value)} 
                      value={description} 
                      disabled={isSaving}
                    /> 
                  </Col>
                </Row>
                <Button 
                  type="button"
                  className="profile-save-button"
                  onClick={handleSubmit}
                  disabled={isSaving}
                >
                  {isSaving ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {t('updating')}...
                    </>
                  ) : (
                    t('update_btn')
                  )}
                </Button>
              </Form>
            </Col>
          </Row>
          <div className="profile-security-section">
            <div className="profile-security-heading">
              <span className="profile-section-icon is-security">
                <i className="fas fa-lock" aria-hidden="true" />
              </span>
              <div>
                <h3>{t('pass_change')}</h3>
                <p>{t("profile_password_help", { defaultValue: "Utilisez un mot de passe unique d’au moins 6 caractères." })}</p>
              </div>
            </div>
            <Form className="profile-form">
              <Row className="profile-form-grid profile-form-grid--password">
                <Col className="form-group">
                  <label htmlFor="feCurrentPassword">{t('current_pass')} <span className="text-danger">*</span></label>
                  <Form.Control
                    type="password"
                    id="feCurrentPassword"
                    placeholder={t('current_pass')}
                    value={password}
                    onChange={handlePasswordChange}
                    className={`form-control form-control-md ${currentMdpError ? "is-invalid" : ""}`}
                    disabled={isSaving}
                  />
                  <div className="invalid-feedback">{currentMdpError}</div>
                </Col>
                <Col className="form-group">
                  <label htmlFor="feNewPassword">{t('new_pass')} <span className="text-danger">*</span></label>
                  <Form.Control
                    type="password"
                    id="feNewPassword"
                    placeholder={t('new_pass')}
                    value={newPassword}
                    onChange={handleNewPasswordChange}
                    className={`form-control form-control-md ${newMdpError ? "is-invalid" : ""}`}
                    disabled={isSaving}
                  />
                  <div className="invalid-feedback">{newMdpError}</div>
                  {newPassword && (
                    <div className="profile-password-strength">
                      <div>
                        <small>{t('password_strength_label')}: {passwordStrength.text}</small>
                        <div className="progress">
                          <div 
                            className="progress-bar" 
                            role="progressbar" 
                            style={{
                              width: `${(passwordStrength.strength / 5) * 100}%`, 
                              backgroundColor: passwordStrength.color
                            }} 
                            aria-valuenow={(passwordStrength.strength / 5) * 100} 
                            aria-valuemin="0" 
                            aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                      <small className="text-muted d-block mt-1">{t('min_6_characters')}</small>
                    </div>
                  )}
                </Col>
                <Col className="form-group">
                  <label htmlFor="feConfNewPass">{t('conf_pass')} <span className="text-danger">*</span></label>
                  <Form.Control
                    type="password"
                    id="feConfNewPass"
                    placeholder={t('conf_pass')}
                    value={confirmPass}
                    onChange={handleConfirmPasswordChange}
                    className={`form-control form-control-md ${confMdpErr ? "is-invalid" : ""}`}
                    disabled={isSaving}
                  />
                  <div className="invalid-feedback">{confMdpErr}</div>
                </Col>            
              </Row>
              <Button 
                type="button"
                className="profile-password-button"
                onClick={handleSubmitPass}
                disabled={isSaving}
              >
                {isSaving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {t('changing')}...
                  </>
                ) : (
                  t('change_btn')
                )}
              </Button>
            </Form>
          </div>
        </ListGroupItem>
      </ListGroup>
    </Card>
  );
};
